import { type ReactNode } from 'react';
import clsx from 'clsx';
import { Heading } from '@hungryroot/ramen';
import { IconHighlightText } from '../IconHighlightText/IconHighlightText';
import styles from './HowItWorks.module.css';

type HowItWorksItem = {
  icon: ReactNode;
  highlightedText: string;
  text: string;
};

type Props = {
  title: string;
  subtitle?: string;
  items: HowItWorksItem[];
  className?: string;
};

export const HowItWorks = ({ title, subtitle, items, className }: Props) => {
  return (
    <div className={clsx(styles.container, className)}>
      <Heading className={styles.title} variant="H1Alt">
        {title}
      </Heading>
      {subtitle && (
        <Heading className={styles.subtitle} variant="H5">
          {subtitle}
        </Heading>
      )}
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.highlightedText}>
            <IconHighlightText
              className={styles.item}
              highlightClassName={styles.highlight}
              {...item}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
